import {FC} from 'react';
import { Link } from 'react-router-dom';

import { routes } from 'routes';
import { RootState } from 'types';
import {useSelector} from 'react-redux';
import { LanguagesSelect } from 'views/components';

import logo from 'assets/images/logo-white.png';
import styles from './AuthLeftBlock.module.css';
import {goToWP, t} from "../../../../../utils";

type Props = {
  title: any;
  backTo?: any;
  description?: any;
};

export const AuthLeftBlock: FC<Props> = ({ title, backTo, description }) => {
  const { windowWidth } = useSelector((state: RootState) => state.app);

  return (
    <>
      <div className={styles.blue}>
        {windowWidth < 1140 ? (
          <div>
            <Link to={'#'} className={styles.logo} onClick={() => goToWP('')}>
              <img src={logo} alt="logo" />
            </Link>
            <LanguagesSelect />
            <div>
              {backTo && (
                <Link to={routes.signin} className={styles.backTo}>
                  {backTo}
                </Link>
              )}
              <h2 className={styles.h2}>{title}</h2>
              {description && <p className={styles.description}>{description}</p>}
            </div>
          </div>
        ) : (
          <div>
            <Link to={'#'} className={styles.logo} onClick={() => goToWP('')}>
              <img src={logo} alt="logo" />
            </Link>
            <h2 className={styles.h2}>{title}</h2>
            {description && <p className={styles.description}>{description}</p>}{' '}
          </div>
        )}
      </div>
    </>
  );
};
